export enum Region {
  AMS = 'AMS',
  APJ = 'APJ',
  EMEA = 'EMEA',
}

export enum Market {
  NORTH_AMERICA = 'North America',
  LATIN_AMERICA = 'Latin America',
  GREATER_ASIA = 'Greater Asia',
  GREATER_CHINA = 'Greater China',
  INDIA_B_SL = 'India, B&SL',
  EMEA = 'EMEA',
}
